import React from 'react'
import {Col, Row} from "components/ui";
import {Form} from "components/ui";
import {useTekstClient} from "hooks/useTekstClient";
import {useSetSearchParams} from "hooks/useSetSearchParams";
import {useSearchParams} from 'next/navigation'

export const FilterVideo = () => {

    const {tekst} = useTekstClient()
    const searchParams = useSearchParams()
    const {deleteParam, updateParam} = useSetSearchParams()
    const filterVideo = !!searchParams.get('vid')

    return <Row className={'ml-1'}>
        <Col>
            <Form.Check
                className={`cursor-pointer`}
                type={'checkbox'}
                id={`video`}
                checked={filterVideo}
                label={tekst('pagina:support:kenniscentrum:filters:video')}
                onChange={(e) => {
                    e.target.checked
                        ? updateParam('vid', e.target.checked ? 1 : 0)
                        : deleteParam('vid')
                }}
            />
        </Col>
    </Row>

}